import apiClient from './client';

export type AssistantAction = { label: string; to: string };
export type AssistantResult = { answer: string | null; actions: AssistantAction[]; fallback: boolean };

/**
 * Ask the admin "Ask Kaunti" assistant. Real county statistics are computed
 * server-side and returned as factual text (never sent to the LLM); navigation
 * / how-to questions are answered by the LLM. Returns a structured result.
 */
export async function askAdminAssistant(message: string): Promise<AssistantResult> {
  try {
    const res = await apiClient.post<{ answer: string | null; actions?: AssistantAction[]; fallback?: boolean }>(
      '/admin/county/assistant',
      { message },
    );
    const data = res.data;
    return {
      answer: data?.answer ?? null,
      actions: data?.actions ?? [],
      fallback: data?.fallback ?? !data?.answer,
    };
  } catch {
    return { answer: null, actions: [], fallback: true };
  }
}
